<template>
  <div class='video_view'>
    <video-player :class="{'_video_live':isLive, 'is-flash':hasUsableFlash, '_video_demand':!isLive}"
      class="video-player  vjs-custom-skin" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)" @waiting="onPlayerWaiting($event)" @playing="onPlayerPlaying($event)"
      @loadeddata="onPlayerLoadeddata($event)" @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)"
      @statechanged="playerStateChanged($event)" @ready="playerReadied" ref="videoPlayer" :playsinline="false"
      :options="playerOptions">
    </video-player>

    <!-- 直播时控制栏 -->
    <div v-show="isControl" id="_control">
      <LiveControls @isShowDanMu='isShowDanMuFn' @control_btn='control_btn' :cloudClassData='cloudClassData' />
    </div>

    <!-- 直播时弹幕组件 -->
    <div v-if="isLive" id="_barrages" class="barrages">
      <LiveBarrages :initDanmu='initDanmu' :isShowDanMu='isShowDanMu' :liveBarrage='liveBarrage' />
    </div>

    <!-- 非直播时，在control中加入弹幕显示关闭功能 -->
    <div v-show="isPlayBackControl" id='_playback_control'>
      <PlayBackControls @isShowDanMu='isShowDanMuFn' :cloudClassData='cloudClassData' />
    </div>

    <!-- 非直播时弹幕组件 -->
    <div v-if="!isLive" id="_playback_barrages" class="playback_barrages">
      <PlayBackBarrages :initDanmu='initDanmu' :playTimeupDate='playTimeupDate' :liveBarrage='liveBarrage'
        :isDanMuPause='isDanMuPause' :isShowDanMu='isShowDanMu' />
    </div>

    <!-- 卡顿的loading -->
    <div v-show="isLoading" class="loading">
      <svg version="1.1" id="dc-spinner" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100"
        viewBox="0 0 38 38" preserveAspectRatio="xMinYMin meet">
        <text x="14" y="21" font-family="Monaco" font-size="4px" style="letter-spacing:0" fill="#000">
          加载中
          <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite"></animate>
        </text>
        <path fill="#333333" d="M20,35c-8.271,0-15-6.729-15-15S11.729,5,20,5s15,6.729,15,15S28.271,35,20,35z M20,5.203
              C11.841,5.203,5.203,11.841,5.203,20c0,8.159,6.638,14.797,14.797,14.797S34.797,28.159,34.797,20
              C34.797,11.841,28.159,5.203,20,5.203z">
        </path>

        <path fill="#333333" d="M20,33.125c-7.237,0-13.125-5.888-13.125-13.125S12.763,6.875,20,6.875S33.125,12.763,33.125,20
              S27.237,33.125,20,33.125z M20,7.078C12.875,7.078,7.078,12.875,7.078,20c0,7.125,5.797,12.922,12.922,12.922
              S32.922,27.125,32.922,20C32.922,12.875,27.125,7.078,20,7.078z">
        </path>

        <path fill="#333333" stroke="#24ba58" stroke-width="1" stroke-miterlimit="10"
          d="M5.203,20c0-8.159,6.638-14.797,14.797-14.797V5C11.729,5,5,11.729,5,20s6.729,15,15,15v-0.203C11.841,34.797,5.203,28.159,5.203,20z"
          transform="rotate(7.82902 20 20)">
          <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" calcMode="spline"
            keySplines="0.4, 0, 0.2, 1" keyTimes="0;1" dur="2s" repeatCount="indefinite"></animateTransform>
        </path>

        <path fill="#333333" stroke="#24ba58" stroke-width="0.5" stroke-miterlimit="10" d="M7.078,20
            c0-7.125,5.797-12.922,12.922-12.922V6.875C12.763,6.875,6.875,12.763,6.875,20S12.763,33.125,20,33.125v-0.203
            C12.875,32.922,7.078,27.125,7.078,20z" transform="rotate(117.007 20 20)">
          <animateTransform attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="1.8s"
            repeatCount="indefinite"></animateTransform>
        </path>
      </svg>
    </div>

  </div>
</template>

<script>
//直播控制台
import LiveControls from "./LiveControls";
//回放控制台
import PlayBackControls from "./PlayBackControls";

//直播时弹幕
import LiveBarrages from "./LiveBarrages";

//非直播时弹幕
import PlayBackBarrages from "./PlayBackBarrages";

import { videoPlayer } from "vue-video-player";
import videojs from "video.js";
import "videojs-flash";

import { getClassDataById } from "@/network/cloudRequest/api";
import utils from "@/util/index";

export default {
  name: "VideoView",
  props: {
    //播放视频项目
    playBackItem: {},
    //用户发送的弹幕库
    liveBarrage: {},
    //视频当前播放时间毫秒
    currentVideoTime: {},
    //监听直播状态
    isEndLive: {}
  },

  components: {
    LiveControls,
    PlayBackControls,
    PlayBackBarrages,
    LiveBarrages
  },

  data() {
    return {
      playerOptions: {
        //开始大按钮
        bigPlayButton: true,
        //如果true,浏览器准备好时开始播放。
        autoplay: true,
        // 默认情况下将会消除任何音频，全部静音。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        //反映原始<video>元素具有一系列子<source>元素的功能的对象数组。
        sources: [],
        techOrder: ["html5", "flash"],
        // techOrder: ["flash"],
        //你的封面地址
        poster: "",
        // poster: "http://test.amdox.com.cn/static/cloud_class/video/default.gif",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        //取消默认控制条
        controls: true,
        //播放速度
        playbackRates: "",
        controlBar: {
          //时间斜杠
          timeDivider: true,
          //总时长
          durationDisplay: true,
          //剩余时间
          remainingTimeDisplay: false,
          //当前时间显示
          currentTimeDisplay: true,
          //全屏按钮
          fullscreenToggle: true,
          //音量栏
          volumePanel: true,
          //音量控制
          volumeControl: false,
          //进度条
          progressControl: true
        }
      },
      //是否是直播
      isLive: true,
      //课程内容
      cloudClassData: {},
      //是否显示loading
      isLoading: false,
      //是否显示直播时的控件
      isControl: false,
      //是否显示非直播时的控件
      isPlayBackControl: false,
      //是否显示直播时弹幕
      isShowDanMu: true,
      //弹幕是否暂停
      isDanMuPause: false,
      //回放视频播放当前时间
      playTimeupDate: "",
      //初始化弹幕
      initDanmu: false,
      //是否加载了flash
      // isFlash: false,
      //直播时是否全屏
      isFull: false
    };
  },

  created() {
    this.init();
  },

  computed: {
    //判断是否加载flash并且处于直播状态
    hasUsableFlash() {
      let flashObj;
      if (typeof window.ActiveXObject != "undefined") {
        flashObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      } else {
        flashObj = navigator.plugins["Shockwave Flash"];
      }
      this.isFlash = flashObj && this.isLive ? true : false;
      return flashObj && this.isLive ? true : false;
    }
  },

  watch: {
    //监听回放播放路径
    playBackItem(newVal) {
      if (newVal != undefined) {
        this.$set(this.playerOptions, "bigPlayButton", true);
        this.$delete(this.playerOptions.sources, 0);
        this.playerOptions.sources.push({
          //类型
          // type: "video/mp4",
          //url地址
          src: newVal.filePlayPath.replace("http:", "https:")
        });
      } else {
        this.$set(this.playerOptions, "bigPlayButton", false);
      }
    },

    // 监听是否加载了flash
    isFlash(newVal) {
      if (newVal) {
        //如果加载了就给封面
        this.$set(
          this.playerOptions,
          "poster",
          "http://test.amdox.com.cn/static/cloud_class/video/default.gif"
        );
      }
    }, //直播结束时进入

    isEndLive(newVal) {
      console.log("isEndLive -> newVal", newVal);
      if (newVal) {
        this.init();
      }
    }
  },

  methods: {
    //初始化数据
    init() {
      //初始化课程数据（课堂数据详情接口获取）
      getClassDataById(this.$route.query.cloudClassId)
        .then(res => {
          if (res.data.success) {
            this.cloudClassData = res.data.data;
            //点播时
            if (res.data.data.type == "2") {
              this.isLive = false;
              //初始化回放视频,有回放时才进来
              if (this.playBackItem) {
                this.$delete(this.playerOptions.sources, 0);
                this.playerOptions.sources.push({
                  //类型
                  // type: "video/mp4",
                  //url地址
                  src: this.playBackItem.filePlayPath
                });
              }
            }

            //直播或者1+N互动课堂
            if (res.data.data.type == "0" || res.data.data.type == "1") {
              // 3.直播已结束
              if (res.data.data.state == "3") {
                this.isLive = false;
                //初始化回放视频,有回放时才进来
                if (this.playBackItem) {
                  this.$delete(this.playerOptions.sources, 0);
                  this.playerOptions.sources.push({
                    //类型
                    // type: "video/mp4",
                    //url地址
                    src: this.playBackItem.filePlayPath
                  });
                }
              }

              //0.直播未开始 1.直播进行中 2.直播下课中
              if (res.data.data.state != "3") {
                this.playerOptions.bigPlayButton = false;
                //直播时，没有回放
                this.isLive = true;
                //正在直播时才赋值直播流地址
                if (res.data.data.state == "1") {
                  //直播时，赋值地址
                  this.$delete(this.playerOptions.sources, 0);
                  this.playerOptions.sources.push({
                    //类型
                    // type: "video/flv",
                    // type: "rtmp/flv",
                    //url地址
                    src: res.data.data.pullPath
                  });
                } else {
                  this.$delete(this.playerOptions.sources, 0);
                  this.playerOptions.sources.push({
                    //类型
                    // type: "video/flv",
                    // type: "rtmp/flv",
                    //url地址
                    src: ""
                  });
                }

                // 判断是否加封面;
                let flashObj;
                if (typeof window.ActiveXObject != "undefined") {
                  flashObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
                } else {
                  flashObj = navigator.plugins["Shockwave Flash"];
                }
                //未加载flash则去除封面
                if (!flashObj) {
                  this.$set(this.playerOptions, "poster", "");
                }
              }
            }
          }
        })

        .catch(err => {
          console.log(err);
        });
    },

    //是否显示弹幕
    isShowDanMuFn(data) {
      this.isShowDanMu = data;
    },

    //播放窗口全屏按钮
    control_btn(name) {
      if (!this.$refs.videoPlayer.player.isFullscreen()) {
        this.isFull = true;
        this.$refs.videoPlayer.player.requestFullscreen();
        this.$refs.videoPlayer.player.isFullscreen(true);
      } else {
        this.isFull = false;
        this.$refs.videoPlayer.player.exitFullscreen();
        this.$refs.videoPlayer.player.isFullscreen(false);
      }
    },

    //开始播放回调
    onPlayerPlay(e) {
      //播放时，不暂停弹幕
      // console.log("开始播放", e);
      this.isDanMuPause = false;
    },

    //暂停播放回调
    onPlayerPause(e) {
      //非直播时
      if (!this.isLive) {
        //暂停播放时，暂停弹幕
        this.isDanMuPause = true;
      }
      // console.log("暂停播放", e);
    },

    //播放结束回调
    onPlayerEnded(e) {
      // console.log("播放结束", e);
    },

    //等待回调  卡顿时
    onPlayerWaiting(e) {
      let a = new Date().getTime();
      // console.log("我卡了", utils.formatTime(a));
      //是否显示loading
      this.isLoading = true;
      //非直播时
      if (!this.isLive) {
        //暂停播放时，暂停弹幕
        this.isDanMuPause = true;
      }
    },

    //播放开始
    onPlayerPlaying(e) {
      // console.log("播放开始");
      this.isLoading = false;
      //非直播时
      if (!this.isLive) {
        //暂停播放时，暂停弹幕
        this.isDanMuPause = false;
      }
    },

    //数据加载完回调
    onPlayerLoadeddata(e) {
      // console.log("数据加载完了", e);
      this.$refs.videoPlayer.player.play();
    },

    //播放进度回调
    onPlayerTimeupdate(e) {
      // console.log("播放进度", e);
    },

    //视频是否有帧
    onPlayerCanplay(e) {
      let a = new Date().getTime();
      // console.log("我好了", utils.formatTime(a));
      this.isLoading = false;
      //非直播时
      if (!this.isLive) {
        //卡顿时，暂停弹幕
        this.isDanMuPause = false;
      }
    },

    //视频是否播放完
    onPlayerCanplaythrough(e) {
      // console.log(e);
    },

    //播放时间即进度状态改变
    playerStateChanged(e) {
      // console.log("播放状态改变", e);
      //回放时使用
      this.playTimeupDate = parseInt(e.timeupdate * 1000);
      //发送消息时使用
      this.$emit("update:currentVideoTime", parseInt(e.timeupdate * 1000));
    },

    //播放器准备就绪
    playerReadied(e) {
      if (this.playerOptions.sources.length != 0) {
        //视频准备好就播放
        this.$refs.videoPlayer.player.play();

        //开始播放,如果是直播,则更改控件
        if (this.isLive) {
          this.isControl = true;

          //将自定义控制栏加入controlBar中
          let _control = document.querySelector("#_control");
          let controlBar = document.querySelector(".vjs-control-bar");
          controlBar.appendChild(_control);

          //开始播放，然后将弹幕加入视频播放器
          let _barrages = document.querySelector("#_barrages");
          let _videoLive = document.querySelector(`#${e.id_}`);
          _videoLive.appendChild(_barrages);
          //初始化弹幕
          this.initDanmu = true;
        }

        //非直播时,更改控件
        if (!this.isLive) {
          this.isPlayBackControl = true;
          //将自定义控制栏加入controlBar中
          let _playback_control = document.querySelector("#_playback_control");
          let controlBar = document.querySelector(".vjs-control-bar");
          controlBar.appendChild(_playback_control);

          //开始播放，然后将弹幕加入视频播放器
          let _playback_barrages = document.querySelector(
            "#_playback_barrages"
          );
          let _videoLive = document.querySelector(`#${e.id_}`);
          _videoLive.appendChild(_playback_barrages);
          //初始化弹幕
          this.initDanmu = true;
        }

        //视频开始播放后启动热键
        let viedoJs = document.querySelector(`#${e.id_}`);
        videojs(viedoJs.id).ready(function() {
          this.hotkeys({
            volumeStep: 0.1,
            seekStep: 5,
            enableModifiersForNumbers: false,
            enableVolumeScroll: true,
            alwaysCaptureHotkeys: true
          });
        });
      }
    }
  }
};
</script>

<style lang='less' scoped>
.video_view {
  position: relative;

  /deep/.video-js {
    background-color: #55595c;
  }

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50px, -50px);
  }
}

//非直播时弹幕位置
.playback_barrages,
.barrages {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
}

//隐藏卡顿的原生loading
/deep/ .vjs-loading-spinner {
  display: none !important;
}

//直播时样式
._video_live {
  //隐藏播放按钮
  /deep/ .vjs-play-control {
    display: none;
  }

  //全屏按钮样式隐藏
  /deep/ .vjs-fullscreen-control {
    display: none;
  }

  //修改音量按钮
  /deep/ .vjs-volume-panel {
    position: absolute !important;
    left: 80px;
    z-index: 1;
  }

  //直播时长
  /deep/ .vjs-current-time {
    position: absolute !important;
    left: 30px;
    z-index: 1;
  }

  //直播斜杠
  /deep/ .vjs-time-divider {
    display: none !important;
  }

  //进度条
  /deep/ .vjs-progress-control {
    display: none !important;
  }

  //总时长
  /deep/ .vjs-duration {
    display: none !important;
  }
}

//直播并且加载了flash禁止单击暂停
.is-flash {
  // 直播时禁止单击暂停
  /deep/ .vjs-tech {
    pointer-events: none;
  }
}

//点播时样式
._video_demand {
  /deep/ .vjs-progress-control {
    position: absolute;
    bottom: 41px;
    left: 0;

    width: 100% !important;
    height: 5px;
  }

  /deep/ .vjs-progress-holder {
    margin: 0 !important;
  }

  /deep/ .vjs-play-progress {
    background-color: #24ba58 !important;
  }

  //全屏按钮样式
  /deep/ .vjs-fullscreen-control {
    position: absolute;
    right: 0;
  }

  //播放大按钮
  /deep/.vjs-big-play-button {
    background-color: #24ba58;
  }
}

//修改音量颜色
/deep/ .vjs-volume-level {
  background-color: #24ba58 !important;
}

//修改按钮外边框
/deep/ .vjs-button {
  outline: none;
}
</style>